$(document).ready(function() {
	$('.faq-show-more-btn').on('click', function() {
		$('.faq-page__items').addClass('faq-page__items--full');
		$('.faq-page__show-more').fadeOut();
	});

	$('.faq-general__category').on('click', function() {
		var categoryId = $(this).data('categoryId');
		var parent = $(this).parents('.faq-general');
		parent.find('.faq-general__category--active').removeClass('faq-general__category--active');
		$(this).addClass('faq-general__category--active');
		parent.find('.faq-general__item--active').fadeOut('fast', function() {
			parent.find('.faq-general__item--active').removeClass('faq-general__item--active');
			parent.find('.faq-general__item[data-category-id="'+categoryId+'"]').fadeIn('fast', function() {
				parent.find('.faq-general__item[data-category-id="'+categoryId+'"]').addClass('faq-general__item--active');
			});
		});
	});

	$('.faq-details__menu .menu__item').on('click', function() {
		var tabType = $(this).data('tabType');
		$('.faq-details__menu .menu__item.active').removeClass('active');
		$(this).addClass('active');
		$('.faq-details__tab.active').fadeOut('fast', function() {
			$('.faq-details__tab.active').removeClass('active');
			$('.faq-details__tab[data-tab-type="'+tabType+'"]').fadeIn('fast', function() {
				$('.faq-details__tab[data-tab-type="'+tabType+'"]').addClass('active');
			});
		});
	});

	$('.faq-general__items .post__title').on('click', function() {
		var post = $(this).parents('.faq-general__post');
		var parent = $(this).parents('.faq-general__posts');

		if(post.hasClass('faq-general__post--active')) {
			post.find('.post__description').slideUp('normal', function() {
				post.removeClass('faq-general__post--active');
			});
		} else {
			parent.find('.faq-general__post--active .post__description').slideUp('fast', function() {
				parent.find('.faq-general__post--active').removeClass('faq-general__post--active');
			});
			post.find('.post__description').slideDown('normal', function() {
				post.addClass('faq-general__post--active');
			});
		}
	});

	$('.faq-item__items .post__title').on('click', function() {
		var post = $(this).parents('.faq-item__post');
		var parent = $(this).parents('.faq-item__items');

		if(post.hasClass('faq-item__post--active')) {
			post.find('.post__description').slideUp('normal', function() {
				post.removeClass('faq-item__post--active');
			});
		} else {
			parent.find('.faq-item__post--active .post__description').slideUp('fast', function() {
				parent.find('.faq-item__post--active').removeClass('faq-item__post--active');
			});
			post.find('.post__description').slideDown('normal', function() {
				post.addClass('faq-item__post--active');
			});
		}
	});
});